export const lineArtLocations: any = {
    "chainer_new": {
        "x": 0,
        "y": 0,
        "width": 128,
        "height": 128
    },
    "chain_swap": {
        "x": 0,
        "y": 128,
        "width": 128,
        "height": 128
    },
    "seeker_2": {
        "x": 0,
        "y": 256,
        "width": 128,
        "height": 128
    },
    "slow_seeker": {
        "x": 0,
        "y": 384,
        "width": 128,
        "height": 128
    },
    "orbiter": {
        "x": 0,
        "y": 512,
        "width": 128,
        "height": 128
    },
    "orbiter_new": {
        "x": 0,
        "y": 640,
        "width": 128,
        "height": 128
    },
    "orbiter_sentry": {
        "x": 0,
        "y": 768,
        "width": 128,
        "height": 128
    },
    "spinner": {
        "x": 0,
        "y": 896,
        "width": 128,
        "height": 128
    },
    "healer": {
        "x": 0,
        "y": 1024,
        "width": 128,
        "height": 128
    },
    "bcell": {
        "x": 0,
        "y": 1152,
        "width": 128,
        "height": 128
    },
    "pusher": {
        "x": 0,
        "y": 1280,
        "width": 127,
        "height": 127
    },
    "bomb": {
        "x": 0,
        "y": 1407,
        "width": 128,
        "height": 128
    },
    "shooter": {
        "x": 0,
        "y": 1535,
        "width": 128,
        "height": 128
    },
    "shooter_new": {
        "x": 0,
        "y": 1663,
        "width": 128,
        "height": 128
    },
    "wall": {
        "x": 0,
        "y": 1791,
        "width": 128,
        "height": 126
    },
    "inverse_wall": {
        "x": 0,
        "y": 1917,
        "width": 128,
        "height": 126
    },
    "sprayer": {
        "x": 0,
        "y": 2043,
        "width": 128,
        "height": 128
    },
    "turret": {
        "x": 0,
        "y": 2171,
        "width": 128,
        "height": 128
    },
    "simple": {
        "x": 0,
        "y": 2299,
        "width": 128,
        "height": 128
    },
    "fist": {
        "x": 0,
        "y": 2427,
        "width": 128,
        "height": 128
    },
    "seeker_factory": {
        "x": 0,
        "y": 2555,
        "width": 128,
        "height": 128
    },
    "magnet_new": {
        "x": 0,
        "y": 2683,
        "width": 128,
        "height": 128
    },
    "electric": {
        "x": 0,
        "y": 2811,
        "width": 128,
        "height": 128
    },
    "electric_wall": {
        "x": 0,
        "y": 2939,
        "width": 128,
        "height": 126
    },
    "electric_kinetic": {
        "x": 0,
        "y": 3065,
        "width": 128,
        "height": 128
    },
    "electric_hungry": {
        "x": 0,
        "y": 3193,
        "width": 128,
        "height": 128
    },
    "electromagnet": {
        "x": 0,
        "y": 3321,
        "width": 128,
        "height": 128
    },
    "Growbomb": {
        "x": 0,
        "y": 3449,
        "width": 128,
        "height": 128
    },
    "Otherbomb": {
        "x": 0,
        "y": 3577,
        "width": 128,
        "height": 128
    },
    "cooldown": {
        "x": 0,
        "y": 3705,
        "width": 128,
        "height": 128
    },
    "tackle": {
        "x": 0,
        "y": 3833,
        "width": 128,
        "height": 128
    },
    "hammer_1": {
        "x": 0,
        "y": 3961,
        "width": 128,
        "height": 128
    },
    "wall_new": {
        "x": 0,
        "y": 4089,
        "width": 128,
        "height": 126
    },
    "plus": {
        "x": 0,
        "y": 4215,
        "width": 128,
        "height": 128
    },
    "coins_2": {
        "x": 0,
        "y": 4343,
        "width": 128,
        "height": 128
    },
    "buffer": {
        "x": 0,
        "y": 4471,
        "width": 128,
        "height": 128
    },
    "nearest_buffer": {
        "x": 0,
        "y": 4599,
        "width": 128,
        "height": 128
    },
    "oblong": {
        "x": 0,
        "y": 4727,
        "width": 128,
        "height": 128
    },
    "mortar": {
        "x": 0,
        "y": 4855,
        "width": 128,
        "height": 128
    },
    "bullet_wall": {
        "x": 0,
        "y": 4983,
        "width": 128,
        "height": 126
    },
    "claymore": {
        "x": 0,
        "y": 5109,
        "width": 128,
        "height": 128
    },
    "swap": {
        "x": 0,
        "y": 5237,
        "width": 128,
        "height": 128
    },
    "wild": {
        "x": 0,
        "y": 5365,
        "width": 128,
        "height": 128
    },
    "Dumbbell": {
        "x": 0,
        "y": 5493,
        "width": 128,
        "height": 128
    },
    "Investment": {
        "x": 0,
        "y": 5621,
        "width": 128,
        "height": 128
    },
    "Spotter": {
        "x": 0,
        "y": 5749,
        "width": 128,
        "height": 127
    },
    "Thorn_wall": {
        "x": 0,
        "y": 5876,
        "width": 128,
        "height": 126
    },
    "minelayer": {
        "x": 0,
        "y": 6002,
        "width": 127,
        "height": 127
    },
    "money_bomb_cannon": {
        "x": 0,
        "y": 6129,
        "width": 128,
        "height": 128
    },
    "money_printer": {
        "x": 0,
        "y": 6257,
        "width": 128,
        "height": 128
    },
    "money_wall": {
        "x": 0,
        "y": 6385,
        "width": 128,
        "height": 126
    },
    "scapegoat": {
        "x": 0,
        "y": 6511,
        "width": 128,
        "height": 128
    },
    "tag_seeker": {
        "x": 0,
        "y": 6639,
        "width": 128,
        "height": 128
    },
    "color_buffer": {
        "x": 0,
        "y": 6767,
        "width": 128,
        "height": 128
    },
    "dropper": {
        "x": 0,
        "y": 6895,
        "width": 128,
        "height": 128
    },
    "infinite_chainer": {
        "x": 0,
        "y": 7023,
        "width": 128,
        "height": 128
    },
    "big_bullet": {
        "x": 0,
        "y": 7151,
        "width": 127,
        "height": 127
    },
    "tag_orbiter": {
        "x": 0,
        "y": 7278,
        "width": 128,
        "height": 128
    },
    "pierce_shooter": {
        "x": 0,
        "y": 7406,
        "width": 128,
        "height": 128
    },
    "heavy_chain": {
        "x": 0,
        "y": 7534,
        "width": 127,
        "height": 127
    },
    "gatling": {
        "x": 0,
        "y": 7661,
        "width": 128,
        "height": 128
    },
    "jumper": {
        "x": 0,
        "y": 7789,
        "width": 128,
        "height": 128
    },
    "pinwheel": {
        "x": 0,
        "y": 7917,
        "width": 128,
        "height": 128
    },
    "bacteriophage": {
        "x": 0,
        "y": 8045,
        "width": 128,
        "height": 128
    },
    "virophage": {
        "x": 0,
        "y": 8173,
        "width": 128,
        "height": 128
    },
    "antibodySeeker": {
        "x": 0,
        "y": 8301,
        "width": 128,
        "height": 128
    },
    "virus": {
        "x": 0,
        "y": 8429,
        "width": 128,
        "height": 128
    },
    "avoider": {
        "x": 0,
        "y": 8557,
        "width": 128,
        "height": 128
    },
    "bulb": {
        "x": 0,
        "y": 8685,
        "width": 128,
        "height": 128
    },
    "sine": {
        "x": 0,
        "y": 8813,
        "width": 128,
        "height": 128
    },
    "hairy": {
        "x": 0,
        "y": 8941,
        "width": 128,
        "height": 128
    },
    "needle": {
        "x": 0,
        "y": 9069,
        "width": 128,
        "height": 128
    },
    "fighter": {
        "x": 0,
        "y": 9197,
        "width": 128,
        "height": 128
    },
    "stack": {
        "x": 0,
        "y": 9325,
        "width": 128,
        "height": 128
    },
    "algae": {
        "x": 0,
        "y": 9453,
        "width": 128,
        "height": 128
    },
    "spike": {
        "x": 0,
        "y": 9581,
        "width": 128,
        "height": 128
    }
};
export const cellLocations: any = {
    "bloodcell": {
        "x": 0,
        "y": 42,
        "width": 42,
        "height": 42
    },
    "infected_bloodcell": {
        "x": 0,
        "y": 126,
        "width": 42,
        "height": 42
    },
    "chainer_new": {
        "x": 0,
        "y": 168,
        "width": 42,
        "height": 42
    },
    "chain_swap": {
        "x": 0,
        "y": 210,
        "width": 42,
        "height": 42
    },
    "seeker_2": {
        "x": 0,
        "y": 252,
        "width": 64,
        "height": 64
    },
    "slow_seeker": {
        "x": 0,
        "y": 316,
        "width": 64,
        "height": 64
    },
    "orbiter": {
        "x": 0,
        "y": 380,
        "width": 104,
        "height": 104
    },
    "orbiter_new": {
        "x": 0,
        "y": 484,
        "width": 104,
        "height": 104
    },
    "orbiter_sentry": {
        "x": 0,
        "y": 588,
        "width": 104,
        "height": 104
    },
    "spinner": {
        "x": 0,
        "y": 692,
        "width": 32,
        "height": 32
    },
    "healer": {
        "x": 0,
        "y": 724,
        "width": 64,
        "height": 64
    },
    "bcell": {
        "x": 0,
        "y": 788,
        "width": 102,
        "height": 102
    },
    "pusher": {
        "x": 0,
        "y": 890,
        "width": 92,
        "height": 92
    },
    "bomb": {
        "x": 0,
        "y": 982,
        "width": 64,
        "height": 64
    },
    "shooter": {
        "x": 0,
        "y": 1046,
        "width": 64,
        "height": 64
    },
    "shooter_new": {
        "x": 0,
        "y": 1110,
        "width": 64,
        "height": 64
    },
    "wall": {
        "x": 0,
        "y": 1174,
        "width": 196,
        "height": 49
    },
    "inverse_wall": {
        "x": 0,
        "y": 1223,
        "width": 196,
        "height": 49
    },
    "sprayer": {
        "x": 0,
        "y": 1272,
        "width": 64,
        "height": 64
    },
    "turret": {
        "x": 0,
        "y": 1336,
        "width": 82,
        "height": 82
    },
    "simple": {
        "x": 0,
        "y": 1418,
        "width": 64,
        "height": 64
    },
    "fist": {
        "x": 0,
        "y": 1482,
        "width": 104,
        "height": 104
    },
    "seeker_factory": {
        "x": 0,
        "y": 1586,
        "width": 128,
        "height": 128
    },
    "magnet_new": {
        "x": 0,
        "y": 1714,
        "width": 54,
        "height": 54
    },
    "electric": {
        "x": 0,
        "y": 1768,
        "width": 54,
        "height": 54
    },
    "electric_wall": {
        "x": 0,
        "y": 1822,
        "width": 196,
        "height": 49
    },
    "electric_kinetic": {
        "x": 0,
        "y": 1871,
        "width": 104,
        "height": 104
    },
    "electric_hungry": {
        "x": 0,
        "y": 1975,
        "width": 88,
        "height": 88
    },
    "electromagnet": {
        "x": 0,
        "y": 2063,
        "width": 104,
        "height": 104
    },
    "Growbomb": {
        "x": 0,
        "y": 2167,
        "width": 64,
        "height": 64
    },
    "Otherbomb": {
        "x": 0,
        "y": 2231,
        "width": 64,
        "height": 64
    },
    "cooldown": {
        "x": 0,
        "y": 2295,
        "width": 42,
        "height": 42
    },
    "tackle": {
        "x": 0,
        "y": 2337,
        "width": 86,
        "height": 86
    },
    "hammer_1": {
        "x": 0,
        "y": 2423,
        "width": 86,
        "height": 86
    },
    "wall_new": {
        "x": 0,
        "y": 2509,
        "width": 128,
        "height": 32
    },
    "plus": {
        "x": 0,
        "y": 2541,
        "width": 52,
        "height": 52
    },
    "coins_2": {
        "x": 0,
        "y": 2593,
        "width": 64,
        "height": 64
    },
    "buffer": {
        "x": 0,
        "y": 2657,
        "width": 64,
        "height": 64
    },
    "nearest_buffer": {
        "x": 0,
        "y": 2721,
        "width": 64,
        "height": 64
    },
    "oblong": {
        "x": 0,
        "y": 2785,
        "width": 54,
        "height": 54
    },
    "mortar": {
        "x": 0,
        "y": 2839,
        "width": 64,
        "height": 64
    },
    "bullet_wall": {
        "x": 0,
        "y": 2903,
        "width": 148,
        "height": 84
    },
    "claymore": {
        "x": 0,
        "y": 2987,
        "width": 64,
        "height": 64
    },
    "swap": {
        "x": 0,
        "y": 3051,
        "width": 82,
        "height": 82
    },
    "wild": {
        "x": 0,
        "y": 3133,
        "width": 64,
        "height": 64
    },
    "Dumbbell": {
        "x": 0,
        "y": 3197,
        "width": 42,
        "height": 42
    },
    "Investment": {
        "x": 0,
        "y": 3239,
        "width": 64,
        "height": 64
    },
    "Spotter": {
        "x": 0,
        "y": 3303,
        "width": 64,
        "height": 42
    },
    "Thorn_wall": {
        "x": 0,
        "y": 3345,
        "width": 196,
        "height": 49
    },
    "minelayer": {
        "x": 0,
        "y": 3394,
        "width": 92,
        "height": 92
    },
    "money_bomb_cannon": {
        "x": 0,
        "y": 3486,
        "width": 128,
        "height": 128
    },
    "money_printer": {
        "x": 0,
        "y": 3614,
        "width": 88,
        "height": 88
    },
    "money_wall": {
        "x": 0,
        "y": 3702,
        "width": 196,
        "height": 49
    },
    "scapegoat": {
        "x": 0,
        "y": 3751,
        "width": 42,
        "height": 42
    },
    "tag_seeker": {
        "x": 0,
        "y": 3793,
        "width": 64,
        "height": 64
    },
    "color_buffer": {
        "x": 0,
        "y": 3857,
        "width": 52,
        "height": 52
    },
    "dropper": {
        "x": 0,
        "y": 3909,
        "width": 94,
        "height": 94
    },
    "infinite_chainer": {
        "x": 0,
        "y": 4003,
        "width": 42,
        "height": 42
    },
    "big_bullet": {
        "x": 0,
        "y": 4045,
        "width": 92,
        "height": 92
    },
    "tag_orbiter": {
        "x": 0,
        "y": 4137,
        "width": 104,
        "height": 104
    },
    "pierce_shooter": {
        "x": 0,
        "y": 4241,
        "width": 82,
        "height": 82
    },
    "heavy_chain": {
        "x": 0,
        "y": 4323,
        "width": 92,
        "height": 92
    },
    "gatling": {
        "x": 0,
        "y": 4415,
        "width": 100,
        "height": 100
    },
    "jumper": {
        "x": 0,
        "y": 4515,
        "width": 24,
        "height": 24
    },
    "pinwheel": {
        "x": 0,
        "y": 4539,
        "width": 24,
        "height": 24
    },
    "bacteriophage": {
        "x": 0,
        "y": 4563,
        "width": 24,
        "height": 24
    },
    "virophage": {
        "x": 0,
        "y": 4587,
        "width": 24,
        "height": 24
    },
    "antibodySeeker": {
        "x": 0,
        "y": 4611,
        "width": 42,
        "height": 42
    },
    "virus": {
        "x": 0,
        "y": 4653,
        "width": 24,
        "height": 24
    },
    "avoider": {
        "x": 0,
        "y": 4677,
        "width": 24,
        "height": 24
    },
    "bulb": {
        "x": 0,
        "y": 4701,
        "width": 24,
        "height": 24
    },
    "sine": {
        "x": 0,
        "y": 4725,
        "width": 36,
        "height": 36
    },
    "hairy": {
        "x": 0,
        "y": 4761,
        "width": 24,
        "height": 24
    },
    "needle": {
        "x": 0,
        "y": 4785,
        "width": 24,
        "height": 24
    },
    "fighter": {
        "x": 0,
        "y": 4809,
        "width": 24,
        "height": 24
    },
    "stack": {
        "x": 0,
        "y": 4833,
        "width": 36,
        "height": 36
    },
    "algae": {
        "x": 0,
        "y": 4869,
        "width": 24,
        "height": 24
    },
    "spike": {
        "x": 0,
        "y": 4893,
        "width": 24,
        "height": 54
    },
    "capsid": {
        "x": 0,
        "y": 4947,
        "width": 12,
        "height": 12
    },
    "interferon": {
        "x": 0,
        "y": 4959,
        "width": 12,
        "height": 12
    },
    "bullet": {
        "x": 0,
        "y": 4971,
        "width": 12,
        "height": 12
    }
};
export const depthLocations: any = {
    "bloodcell": {
        "x": 0,
        "y": 42,
        "width": 42,
        "height": 42
    },
    "infected_bloodcell": {
        "x": 0,
        "y": 126,
        "width": 42,
        "height": 42
    },
    "chainer_new": {
        "x": 0,
        "y": 168,
        "width": 42,
        "height": 42
    },
    "chain_swap": {
        "x": 0,
        "y": 210,
        "width": 42,
        "height": 42
    },
    "seeker_2": {
        "x": 0,
        "y": 252,
        "width": 64,
        "height": 64
    },
    "slow_seeker": {
        "x": 0,
        "y": 316,
        "width": 64,
        "height": 64
    },
    "orbiter": {
        "x": 0,
        "y": 380,
        "width": 104,
        "height": 104
    },
    "orbiter_new": {
        "x": 0,
        "y": 484,
        "width": 104,
        "height": 104
    },
    "orbiter_sentry": {
        "x": 0,
        "y": 588,
        "width": 104,
        "height": 104
    },
    "spinner": {
        "x": 0,
        "y": 692,
        "width": 32,
        "height": 32
    },
    "healer": {
        "x": 0,
        "y": 724,
        "width": 64,
        "height": 64
    },
    "bcell": {
        "x": 0,
        "y": 788,
        "width": 102,
        "height": 102
    },
    "pusher": {
        "x": 0,
        "y": 890,
        "width": 92,
        "height": 92
    },
    "bomb": {
        "x": 0,
        "y": 982,
        "width": 64,
        "height": 64
    },
    "shooter": {
        "x": 0,
        "y": 1046,
        "width": 64,
        "height": 64
    },
    "shooter_new": {
        "x": 0,
        "y": 1110,
        "width": 64,
        "height": 64
    },
    "wall": {
        "x": 0,
        "y": 1174,
        "width": 196,
        "height": 49
    },
    "inverse_wall": {
        "x": 0,
        "y": 1223,
        "width": 196,
        "height": 49
    },
    "sprayer": {
        "x": 0,
        "y": 1272,
        "width": 64,
        "height": 64
    },
    "turret": {
        "x": 0,
        "y": 1336,
        "width": 82,
        "height": 82
    },
    "simple": {
        "x": 0,
        "y": 1418,
        "width": 64,
        "height": 64
    },
    "fist": {
        "x": 0,
        "y": 1482,
        "width": 104,
        "height": 104
    },
    "seeker_factory": {
        "x": 0,
        "y": 1586,
        "width": 128,
        "height": 128
    },
    "magnet_new": {
        "x": 0,
        "y": 1714,
        "width": 54,
        "height": 54
    },
    "electric": {
        "x": 0,
        "y": 1768,
        "width": 54,
        "height": 54
    },
    "electric_wall": {
        "x": 0,
        "y": 1822,
        "width": 196,
        "height": 49
    },
    "electric_kinetic": {
        "x": 0,
        "y": 1871,
        "width": 104,
        "height": 104
    },
    "electric_hungry": {
        "x": 0,
        "y": 1975,
        "width": 88,
        "height": 88
    },
    "electromagnet": {
        "x": 0,
        "y": 2063,
        "width": 104,
        "height": 104
    },
    "Growbomb": {
        "x": 0,
        "y": 2167,
        "width": 64,
        "height": 64
    },
    "Otherbomb": {
        "x": 0,
        "y": 2231,
        "width": 64,
        "height": 64
    },
    "cooldown": {
        "x": 0,
        "y": 2295,
        "width": 42,
        "height": 42
    },
    "tackle": {
        "x": 0,
        "y": 2337,
        "width": 86,
        "height": 86
    },
    "hammer_1": {
        "x": 0,
        "y": 2423,
        "width": 86,
        "height": 86
    },
    "wall_new": {
        "x": 0,
        "y": 2509,
        "width": 128,
        "height": 32
    },
    "plus": {
        "x": 0,
        "y": 2541,
        "width": 52,
        "height": 52
    },
    "coins_2": {
        "x": 0,
        "y": 2593,
        "width": 64,
        "height": 64
    },
    "buffer": {
        "x": 0,
        "y": 2657,
        "width": 64,
        "height": 64
    },
    "nearest_buffer": {
        "x": 0,
        "y": 2721,
        "width": 64,
        "height": 64
    },
    "oblong": {
        "x": 0,
        "y": 2785,
        "width": 54,
        "height": 54
    },
    "mortar": {
        "x": 0,
        "y": 2839,
        "width": 64,
        "height": 64
    },
    "bullet_wall": {
        "x": 0,
        "y": 2903,
        "width": 148,
        "height": 84
    },
    "claymore": {
        "x": 0,
        "y": 2987,
        "width": 64,
        "height": 64
    },
    "swap": {
        "x": 0,
        "y": 3051,
        "width": 82,
        "height": 82
    },
    "wild": {
        "x": 0,
        "y": 3133,
        "width": 64,
        "height": 64
    },
    "Dumbbell": {
        "x": 0,
        "y": 3197,
        "width": 42,
        "height": 42
    },
    "Investment": {
        "x": 0,
        "y": 3239,
        "width": 64,
        "height": 64
    },
    "Spotter": {
        "x": 0,
        "y": 3303,
        "width": 64,
        "height": 42
    },
    "Thorn_wall": {
        "x": 0,
        "y": 3345,
        "width": 196,
        "height": 49
    },
    "minelayer": {
        "x": 0,
        "y": 3394,
        "width": 92,
        "height": 92
    },
    "money_bomb_cannon": {
        "x": 0,
        "y": 3486,
        "width": 128,
        "height": 128
    },
    "money_printer": {
        "x": 0,
        "y": 3614,
        "width": 88,
        "height": 88
    },
    "money_wall": {
        "x": 0,
        "y": 3702,
        "width": 196,
        "height": 49
    },
    "scapegoat": {
        "x": 0,
        "y": 3751,
        "width": 42,
        "height": 42
    },
    "tag_seeker": {
        "x": 0,
        "y": 3793,
        "width": 64,
        "height": 64
    },
    "color_buffer": {
        "x": 0,
        "y": 3857,
        "width": 52,
        "height": 52
    },
    "dropper": {
        "x": 0,
        "y": 3909,
        "width": 94,
        "height": 94
    },
    "infinite_chainer": {
        "x": 0,
        "y": 4003,
        "width": 42,
        "height": 42
    },
    "big_bullet": {
        "x": 0,
        "y": 4045,
        "width": 92,
        "height": 92
    },
    "tag_orbiter": {
        "x": 0,
        "y": 4137,
        "width": 104,
        "height": 104
    },
    "pierce_shooter": {
        "x": 0,
        "y": 4241,
        "width": 82,
        "height": 82
    },
    "heavy_chain": {
        "x": 0,
        "y": 4323,
        "width": 92,
        "height": 92
    },
    "gatling": {
        "x": 0,
        "y": 4415,
        "width": 100,
        "height": 100
    },
    "jumper": {
        "x": 0,
        "y": 4515,
        "width": 24,
        "height": 24
    },
    "pinwheel": {
        "x": 0,
        "y": 4539,
        "width": 24,
        "height": 24
    },
    "bacteriophage": {
        "x": 0,
        "y": 4563,
        "width": 24,
        "height": 24
    },
    "virophage": {
        "x": 0,
        "y": 4587,
        "width": 24,
        "height": 24
    },
    "antibodySeeker": {
        "x": 0,
        "y": 4611,
        "width": 42,
        "height": 42
    },
    "virus": {
        "x": 0,
        "y": 4653,
        "width": 24,
        "height": 24
    },
    "avoider": {
        "x": 0,
        "y": 4677,
        "width": 24,
        "height": 24
    },
    "bulb": {
        "x": 0,
        "y": 4701,
        "width": 24,
        "height": 24
    },
    "sine": {
        "x": 0,
        "y": 4725,
        "width": 36,
        "height": 36
    },
    "hairy": {
        "x": 0,
        "y": 4761,
        "width": 24,
        "height": 24
    },
    "needle": {
        "x": 0,
        "y": 4785,
        "width": 24,
        "height": 24
    },
    "fighter": {
        "x": 0,
        "y": 4809,
        "width": 24,
        "height": 24
    },
    "stack": {
        "x": 0,
        "y": 4833,
        "width": 36,
        "height": 36
    },
    "algae": {
        "x": 0,
        "y": 4869,
        "width": 24,
        "height": 24
    },
    "spike": {
        "x": 0,
        "y": 4893,
        "width": 24,
        "height": 54
    },
    "capsid": {
        "x": 0,
        "y": 4947,
        "width": 12,
        "height": 12
    },
    "interferon": {
        "x": 0,
        "y": 4959,
        "width": 12,
        "height": 12
    },
    "bullet": {
        "x": 0,
        "y": 4971,
        "width": 12,
        "height": 12
    }
};
export const membraneLocations: any = {
    "bloodcell": {
        "x": 0,
        "y": 0,
        "width": 42,
        "height": 42
    },
    "infected_bloodcell": {
        "x": 0,
        "y": 42,
        "width": 42,
        "height": 42
    },
    "chainer_new": {
        "x": 0,
        "y": 84,
        "width": 42,
        "height": 42
    },
    "chain_swap": {
        "x": 0,
        "y": 126,
        "width": 42,
        "height": 42
    },
    "seeker_2": {
        "x": 0,
        "y": 168,
        "width": 64,
        "height": 64
    },
    "slow_seeker": {
        "x": 0,
        "y": 232,
        "width": 64,
        "height": 64
    },
    "orbiter": {
        "x": 0,
        "y": 296,
        "width": 104,
        "height": 104
    },
    "orbiter_new": {
        "x": 0,
        "y": 400,
        "width": 104,
        "height": 104
    },
    "orbiter_sentry": {
        "x": 0,
        "y": 504,
        "width": 104,
        "height": 104
    },
    "spinner": {
        "x": 0,
        "y": 608,
        "width": 32,
        "height": 32
    },
    "healer": {
        "x": 0,
        "y": 640,
        "width": 64,
        "height": 64
    },
    "bcell": {
        "x": 0,
        "y": 704,
        "width": 102,
        "height": 102
    },
    "pusher": {
        "x": 0,
        "y": 806,
        "width": 92,
        "height": 92
    },
    "bomb": {
        "x": 0,
        "y": 898,
        "width": 64,
        "height": 64
    },
    "shooter": {
        "x": 0,
        "y": 962,
        "width": 64,
        "height": 64
    },
    "shooter_new": {
        "x": 0,
        "y": 1026,
        "width": 64,
        "height": 64
    },
    "wall": {
        "x": 0,
        "y": 1090,
        "width": 196,
        "height": 49
    },
    "inverse_wall": {
        "x": 0,
        "y": 1139,
        "width": 196,
        "height": 49
    },
    "sprayer": {
        "x": 0,
        "y": 1188,
        "width": 64,
        "height": 64
    },
    "turret": {
        "x": 0,
        "y": 1252,
        "width": 82,
        "height": 82
    },
    "simple": {
        "x": 0,
        "y": 1334,
        "width": 64,
        "height": 64
    },
    "fist": {
        "x": 0,
        "y": 1398,
        "width": 104,
        "height": 104
    },
    "seeker_factory": {
        "x": 0,
        "y": 1502,
        "width": 128,
        "height": 128
    },
    "magnet_new": {
        "x": 0,
        "y": 1630,
        "width": 54,
        "height": 54
    },
    "electric": {
        "x": 0,
        "y": 1684,
        "width": 54,
        "height": 54
    },
    "electric_wall": {
        "x": 0,
        "y": 1738,
        "width": 196,
        "height": 49
    },
    "electric_kinetic": {
        "x": 0,
        "y": 1787,
        "width": 104,
        "height": 104
    },
    "electric_hungry": {
        "x": 0,
        "y": 1891,
        "width": 88,
        "height": 88
    },
    "electromagnet": {
        "x": 0,
        "y": 1979,
        "width": 104,
        "height": 104
    },
    "Growbomb": {
        "x": 0,
        "y": 2083,
        "width": 64,
        "height": 64
    },
    "Otherbomb": {
        "x": 0,
        "y": 2147,
        "width": 64,
        "height": 64
    },
    "cooldown": {
        "x": 0,
        "y": 2211,
        "width": 42,
        "height": 42
    },
    "tackle": {
        "x": 0,
        "y": 2253,
        "width": 86,
        "height": 86
    },
    "hammer_1": {
        "x": 0,
        "y": 2339,
        "width": 86,
        "height": 86
    },
    "wall_new": {
        "x": 0,
        "y": 2425,
        "width": 128,
        "height": 32
    },
    "plus": {
        "x": 0,
        "y": 2457,
        "width": 52,
        "height": 52
    },
    "coins_2": {
        "x": 0,
        "y": 2509,
        "width": 64,
        "height": 64
    },
    "buffer": {
        "x": 0,
        "y": 2573,
        "width": 64,
        "height": 64
    },
    "nearest_buffer": {
        "x": 0,
        "y": 2637,
        "width": 64,
        "height": 64
    },
    "oblong": {
        "x": 0,
        "y": 2701,
        "width": 54,
        "height": 54
    },
    "mortar": {
        "x": 0,
        "y": 2755,
        "width": 64,
        "height": 64
    },
    "bullet_wall": {
        "x": 0,
        "y": 2819,
        "width": 148,
        "height": 84
    },
    "claymore": {
        "x": 0,
        "y": 2903,
        "width": 64,
        "height": 64
    },
    "swap": {
        "x": 0,
        "y": 2967,
        "width": 82,
        "height": 82
    },
    "wild": {
        "x": 0,
        "y": 3049,
        "width": 64,
        "height": 64
    },
    "Dumbbell": {
        "x": 0,
        "y": 3113,
        "width": 42,
        "height": 42
    },
    "Investment": {
        "x": 0,
        "y": 3155,
        "width": 64,
        "height": 64
    },
    "Spotter": {
        "x": 0,
        "y": 3219,
        "width": 64,
        "height": 42
    },
    "Thorn_wall": {
        "x": 0,
        "y": 3261,
        "width": 196,
        "height": 49
    },
    "minelayer": {
        "x": 0,
        "y": 3310,
        "width": 92,
        "height": 92
    },
    "money_bomb_cannon": {
        "x": 0,
        "y": 3402,
        "width": 128,
        "height": 128
    },
    "money_printer": {
        "x": 0,
        "y": 3530,
        "width": 88,
        "height": 88
    },
    "money_wall": {
        "x": 0,
        "y": 3618,
        "width": 196,
        "height": 49
    },
    "scapegoat": {
        "x": 0,
        "y": 3667,
        "width": 42,
        "height": 42
    },
    "tag_seeker": {
        "x": 0,
        "y": 3709,
        "width": 64,
        "height": 64
    },
    "color_buffer": {
        "x": 0,
        "y": 3773,
        "width": 52,
        "height": 52
    },
    "dropper": {
        "x": 0,
        "y": 3825,
        "width": 94,
        "height": 94
    },
    "infinite_chainer": {
        "x": 0,
        "y": 3919,
        "width": 42,
        "height": 42
    },
    "big_bullet": {
        "x": 0,
        "y": 3961,
        "width": 92,
        "height": 92
    },
    "tag_orbiter": {
        "x": 0,
        "y": 4053,
        "width": 104,
        "height": 104
    },
    "pierce_shooter": {
        "x": 0,
        "y": 4157,
        "width": 82,
        "height": 82
    },
    "heavy_chain": {
        "x": 0,
        "y": 4239,
        "width": 92,
        "height": 92
    },
    "gatling": {
        "x": 0,
        "y": 4331,
        "width": 100,
        "height": 100
    }
};
export const ciliaLocations: any = {
    "seeker_2": {
        "x": 0,
        "y": 0,
        "width": 96,
        "height": 96
    },
    "slow_seeker": {
        "x": 0,
        "y": 96,
        "width": 96,
        "height": 96
    },
    "orbiter": {
        "x": 0,
        "y": 192,
        "width": 156,
        "height": 156
    },
    "orbiter_new": {
        "x": 0,
        "y": 348,
        "width": 156,
        "height": 156
    },
    "orbiter_sentry": {
        "x": 0,
        "y": 504,
        "width": 156,
        "height": 156
    },
    "bcell": {
        "x": 0,
        "y": 660,
        "width": 152,
        "height": 152
    },
    "tackle": {
        "x": 0,
        "y": 812,
        "width": 128,
        "height": 128
    },
    "hammer_1": {
        "x": 0,
        "y": 940,
        "width": 128,
        "height": 128
    },
    "swap": {
        "x": 0,
        "y": 1068,
        "width": 122,
        "height": 122
    },
    "minelayer": {
        "x": 0,
        "y": 1190,
        "width": 138,
        "height": 138
    },
    "tag_seeker": {
        "x": 0,
        "y": 1328,
        "width": 96,
        "height": 96
    },
    "tag_orbiter": {
        "x": 0,
        "y": 1424,
        "width": 156,
        "height": 156
    }
};
export const glowLocations: any = {
    "bloodcell": {
        "x": 0,
        "y": 21,
        "width": 21,
        "height": 21
    },
    "infected_bloodcell": {
        "x": 0,
        "y": 63,
        "width": 21,
        "height": 21
    },
    "chainer_new": {
        "x": 0,
        "y": 84,
        "width": 21,
        "height": 21
    },
    "chain_swap": {
        "x": 0,
        "y": 105,
        "width": 21,
        "height": 21
    },
    "seeker_2": {
        "x": 0,
        "y": 126,
        "width": 32,
        "height": 32
    },
    "slow_seeker": {
        "x": 0,
        "y": 158,
        "width": 32,
        "height": 32
    },
    "orbiter": {
        "x": 0,
        "y": 190,
        "width": 52,
        "height": 52
    },
    "orbiter_new": {
        "x": 0,
        "y": 242,
        "width": 52,
        "height": 52
    },
    "orbiter_sentry": {
        "x": 0,
        "y": 294,
        "width": 52,
        "height": 52
    },
    "spinner": {
        "x": 0,
        "y": 346,
        "width": 16,
        "height": 16
    },
    "healer": {
        "x": 0,
        "y": 362,
        "width": 32,
        "height": 32
    },
    "bcell": {
        "x": 0,
        "y": 394,
        "width": 51,
        "height": 51
    },
    "pusher": {
        "x": 0,
        "y": 445,
        "width": 46,
        "height": 46
    },
    "bomb": {
        "x": 0,
        "y": 491,
        "width": 32,
        "height": 32
    },
    "shooter": {
        "x": 0,
        "y": 523,
        "width": 32,
        "height": 32
    },
    "shooter_new": {
        "x": 0,
        "y": 555,
        "width": 32,
        "height": 32
    },
    "wall": {
        "x": 0,
        "y": 587,
        "width": 98,
        "height": 24
    },
    "inverse_wall": {
        "x": 0,
        "y": 611,
        "width": 98,
        "height": 24
    },
    "sprayer": {
        "x": 0,
        "y": 635,
        "width": 32,
        "height": 32
    },
    "turret": {
        "x": 0,
        "y": 667,
        "width": 41,
        "height": 41
    },
    "simple": {
        "x": 0,
        "y": 708,
        "width": 32,
        "height": 32
    },
    "fist": {
        "x": 0,
        "y": 740,
        "width": 52,
        "height": 52
    },
    "seeker_factory": {
        "x": 0,
        "y": 792,
        "width": 64,
        "height": 64
    },
    "magnet_new": {
        "x": 0,
        "y": 856,
        "width": 27,
        "height": 27
    },
    "electric": {
        "x": 0,
        "y": 883,
        "width": 27,
        "height": 27
    },
    "electric_wall": {
        "x": 0,
        "y": 910,
        "width": 98,
        "height": 24
    },
    "electric_kinetic": {
        "x": 0,
        "y": 934,
        "width": 52,
        "height": 52
    },
    "electric_hungry": {
        "x": 0,
        "y": 986,
        "width": 44,
        "height": 44
    },
    "electromagnet": {
        "x": 0,
        "y": 1030,
        "width": 52,
        "height": 52
    },
    "Growbomb": {
        "x": 0,
        "y": 1082,
        "width": 32,
        "height": 32
    },
    "Otherbomb": {
        "x": 0,
        "y": 1114,
        "width": 32,
        "height": 32
    },
    "cooldown": {
        "x": 0,
        "y": 1146,
        "width": 21,
        "height": 21
    },
    "tackle": {
        "x": 0,
        "y": 1167,
        "width": 43,
        "height": 43
    },
    "hammer_1": {
        "x": 0,
        "y": 1210,
        "width": 43,
        "height": 43
    },
    "wall_new": {
        "x": 0,
        "y": 1253,
        "width": 64,
        "height": 16
    },
    "plus": {
        "x": 0,
        "y": 1269,
        "width": 26,
        "height": 26
    },
    "coins_2": {
        "x": 0,
        "y": 1295,
        "width": 32,
        "height": 32
    },
    "buffer": {
        "x": 0,
        "y": 1327,
        "width": 32,
        "height": 32
    },
    "nearest_buffer": {
        "x": 0,
        "y": 1359,
        "width": 32,
        "height": 32
    },
    "oblong": {
        "x": 0,
        "y": 1391,
        "width": 27,
        "height": 27
    },
    "mortar": {
        "x": 0,
        "y": 1418,
        "width": 32,
        "height": 32
    },
    "bullet_wall": {
        "x": 0,
        "y": 1450,
        "width": 74,
        "height": 42
    },
    "claymore": {
        "x": 0,
        "y": 1492,
        "width": 32,
        "height": 32
    },
    "swap": {
        "x": 0,
        "y": 1524,
        "width": 41,
        "height": 41
    },
    "wild": {
        "x": 0,
        "y": 1565,
        "width": 32,
        "height": 32
    },
    "Dumbbell": {
        "x": 0,
        "y": 1597,
        "width": 21,
        "height": 21
    },
    "Investment": {
        "x": 0,
        "y": 1618,
        "width": 32,
        "height": 32
    },
    "Spotter": {
        "x": 0,
        "y": 1650,
        "width": 32,
        "height": 21
    },
    "Thorn_wall": {
        "x": 0,
        "y": 1671,
        "width": 98,
        "height": 24
    },
    "minelayer": {
        "x": 0,
        "y": 1695,
        "width": 46,
        "height": 46
    },
    "money_bomb_cannon": {
        "x": 0,
        "y": 1741,
        "width": 64,
        "height": 64
    },
    "money_printer": {
        "x": 0,
        "y": 1805,
        "width": 44,
        "height": 44
    },
    "money_wall": {
        "x": 0,
        "y": 1849,
        "width": 98,
        "height": 24
    },
    "scapegoat": {
        "x": 0,
        "y": 1873,
        "width": 21,
        "height": 21
    },
    "tag_seeker": {
        "x": 0,
        "y": 1894,
        "width": 32,
        "height": 32
    },
    "color_buffer": {
        "x": 0,
        "y": 1926,
        "width": 26,
        "height": 26
    },
    "dropper": {
        "x": 0,
        "y": 1952,
        "width": 47,
        "height": 47
    },
    "infinite_chainer": {
        "x": 0,
        "y": 1999,
        "width": 21,
        "height": 21
    },
    "big_bullet": {
        "x": 0,
        "y": 2020,
        "width": 46,
        "height": 46
    },
    "tag_orbiter": {
        "x": 0,
        "y": 2066,
        "width": 52,
        "height": 52
    },
    "pierce_shooter": {
        "x": 0,
        "y": 2118,
        "width": 41,
        "height": 41
    },
    "heavy_chain": {
        "x": 0,
        "y": 2159,
        "width": 46,
        "height": 46
    },
    "gatling": {
        "x": 0,
        "y": 2205,
        "width": 50,
        "height": 50
    },
    "jumper": {
        "x": 0,
        "y": 2255,
        "width": 12,
        "height": 12
    },
    "pinwheel": {
        "x": 0,
        "y": 2267,
        "width": 12,
        "height": 12
    },
    "bacteriophage": {
        "x": 0,
        "y": 2279,
        "width": 12,
        "height": 12
    },
    "virophage": {
        "x": 0,
        "y": 2291,
        "width": 12,
        "height": 12
    },
    "antibodySeeker": {
        "x": 0,
        "y": 2303,
        "width": 21,
        "height": 21
    },
    "virus": {
        "x": 0,
        "y": 2324,
        "width": 12,
        "height": 12
    },
    "avoider": {
        "x": 0,
        "y": 2336,
        "width": 12,
        "height": 12
    },
    "bulb": {
        "x": 0,
        "y": 2348,
        "width": 12,
        "height": 12
    },
    "sine": {
        "x": 0,
        "y": 2360,
        "width": 18,
        "height": 18
    },
    "hairy": {
        "x": 0,
        "y": 2378,
        "width": 12,
        "height": 12
    },
    "needle": {
        "x": 0,
        "y": 2390,
        "width": 12,
        "height": 12
    },
    "fighter": {
        "x": 0,
        "y": 2402,
        "width": 12,
        "height": 12
    },
    "stack": {
        "x": 0,
        "y": 2414,
        "width": 18,
        "height": 18
    },
    "algae": {
        "x": 0,
        "y": 2432,
        "width": 12,
        "height": 12
    },
    "spike": {
        "x": 0,
        "y": 2444,
        "width": 12,
        "height": 27
    },
    "capsid": {
        "x": 0,
        "y": 2471,
        "width": 6,
        "height": 6
    },
    "interferon": {
        "x": 0,
        "y": 2477,
        "width": 6,
        "height": 6
    },
    "bullet": {
        "x": 0,
        "y": 2483,
        "width": 6,
        "height": 6
    }
};
